import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import useLanguageChange from "../../hooks/useLanguageChange";
import { setIsLocalUserOffline, setIsLocalUserReconnecting } from "../../reducers/battery-network-info-reducer";
import { checkOnlineStatus } from "./NetworkUtils";

const NetworkConnectionMonitor = () => {
    const dispatch = useDispatch();
    const localisedValues = useLanguageChange();
    const { isLocalUserOffline, isLocalUserReconnecting } = useSelector((state) => state.batteryNetworkInfo);
    const { isOfflineModeActive } = useSelector((state) => state.offlineMode);

    const [checkSecondTimeStatus, setCheckSecondTimeStatus] = useState(false);
    const [onloadCheckNetworkStatus, setOnloadCheckNetworkStatus] = useState(false);

    const checkNetworkStatusRef = useRef(false);
    const isLocalUserReconnectingRef = useRef(false);

    useEffect(() => {
        const handleOnlineStatusCheck = async () => {
            if (onloadCheckNetworkStatus) return;

            const result = await checkOnlineStatus();

            if (result) {
                // Online
                isLocalUserReconnectingRef.current = false;
                dispatch(setIsLocalUserOffline(false));
                dispatch(setIsLocalUserReconnecting(false));
                setCheckSecondTimeStatus(false);
            } else if (!isLocalUserOffline && !result && !checkSecondTimeStatus) {
                // first time offline
                dispatch(setIsLocalUserReconnecting(true));
                setCheckSecondTimeStatus(true);
            } else if (!isLocalUserOffline && !result && checkSecondTimeStatus) {
                // second time offline
                dispatch(setIsLocalUserReconnecting(false));
                dispatch(setIsLocalUserOffline(true));
                isLocalUserReconnectingRef.current = true;
            }
        };

        const handleInitialLoad = async () => {
            if (navigator.onLine) {
                isLocalUserReconnectingRef.current = false;
                dispatch(setIsLocalUserOffline(false));
                dispatch(setIsLocalUserReconnecting(false));
                setOnloadCheckNetworkStatus(true);
                clearInterval(onLineInterval);
            } else {
                const statusValue = (await checkOnlineStatus()) ? "Online" : "Offline";
                if (statusValue === "Offline") {
                    isLocalUserReconnectingRef.current = true;
                    dispatch(setIsLocalUserOffline(true));
                    dispatch(setIsLocalUserReconnecting(false));
                } else {
                    isLocalUserReconnectingRef.current = false;
                    dispatch(setIsLocalUserOffline(false));
                    dispatch(setIsLocalUserReconnecting(false));
                }
            }
        };

        const handleOnline = () => {
            isLocalUserReconnectingRef.current = false;
            dispatch(setIsLocalUserOffline(false));
            dispatch(setIsLocalUserReconnecting(false));
        };

        const handleOffline = async () => {
            isLocalUserReconnectingRef.current = true;
            dispatch(setIsLocalUserReconnecting(true));

            // Check network status after 10 seconds
            setTimeout(() => {
                checkNetworkStatusRef.current = true;
                handleCheckNetworkStatus();
            }, 10000);
        };

        const onLineInterval = setInterval(handleOnlineStatusCheck, 10000);

        window.addEventListener("load", handleInitialLoad);
        window.addEventListener("online", handleOnline);
        window.addEventListener("offline", handleOffline);

        return () => {
            clearInterval(onLineInterval);
            window.removeEventListener("load", handleInitialLoad);
            window.removeEventListener("online", handleOnline);
            window.removeEventListener("offline", handleOffline);
        };
    }, []);

    const handleCheckNetworkStatus = () => {
        console.warn("::after 10 second if still not connected");
        if (isLocalUserReconnectingRef.current) {
            dispatch(setIsLocalUserReconnecting(false));
            dispatch(setIsLocalUserOffline(true));
        } else {
            dispatch(setIsLocalUserReconnecting(false));
            dispatch(setIsLocalUserOffline(false));
        }
        isLocalUserReconnectingRef.current = false; // Update ref value
    };

    return (
        <>
            {!isOfflineModeActive && isLocalUserOffline && (
                <div className='alert-box'>
                    <div className='alert-wrap offline-alert'>
                        <div className='alert-wrap-in text-center'>{localisedValues["you_are_offline"]}</div>
                    </div>
                </div>
            )}

            {!isOfflineModeActive && isLocalUserReconnecting && (
                <div className='alert-box'>
                    <div className='alert-wrap reconnecting-alert'>
                        <div className='alert-wrap-in text-center'>{localisedValues["reconnecting"]}</div>
                    </div>
                </div>
            )}
        </>
    );
};

export default NetworkConnectionMonitor;
